import React from 'react';

const Settings = () => {
  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold mb-4">Settings</h2>
      <div className="bg-white rounded-lg shadow p-4">
        <p className="text-gray-600">Settings functionality coming soon...</p>
      </div>
    </div>
  );
};

export default Settings; 